// jquery.module.js
import jQuery from 'jquery'
window.jQuery = jQuery
export default window.jQuery.noConflict(true)
